import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IParamposList } from '../models/models'

export class ListAkOdePosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'posTransaction/listAkOdeInsatallment',
      requesterInfo,
    })
  }

  public async listAkOdePosInsatallment(request: number): Promise<IParamposList[]> {
    this.props.url = `${this.props.url}/?bankId=${request}`
    return await this.getAsync<IParamposList[]>()
  }

  public async listAkOdePosInsatallmentNoBank(): Promise<IParamposList[]> {
    this.props.url = `posTransaction/listAkOdeInsatallmentNoBank`
    return await this.getAsync<IParamposList[]>()
  }
}
